import { render, staticRenderFns } from "./ActivityComment.vue?vue&type=template&id=0eb0c787&scoped=true&lang=pug&"
import script from "./ActivityComment.vue?vue&type=script&lang=js&"
export * from "./ActivityComment.vue?vue&type=script&lang=js&"
import style0 from "./ActivityComment.vue?vue&type=style&index=0&id=0eb0c787&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb0c787",
  null
  
)

export default component.exports